var buttonSpinner = {
	data: {
		isLoading: [],
	},
	methods: {
		startBtnLoader: function(element) {
			if (!element) return;
			if (!element.querySelector('span')) {
				$d.append('<span></span>', element);
			}
			element.classList.add('loader');
			this.isLoading.push(element);
		},
		stopBtnLoader: function(element) {
			if (element) {
				element.classList.remove('loader');
				this.isLoading.splice(this.isLoading.indexOf(element), 1);
			} else {
				for (var i = 0 ; i < this.isLoading.length; i++) {
					this.isLoading[i].classList.remove('loader');
				}
				this.isLoading = [];
			}
			// $d.forEach(qSA('button.loader, .button.loader'), function($btn) {
			// });
		}
	}
};